interface MappingOption {
	id: string;
	title: string;
}

interface FoundField {
	foundField: string;
	assignedField: string;
}

/**
 * Returns the list of acceptable field-combinations expressed via human-readable
 * option titles, when the supplied foundFields do not satisfy any of the
 * minimumFields combinations. Returns null when the requirements are already
 * met or when there are no foundFields yet.
 */
export const getMissingMappingCombinations = (
	minimumFields: string[][],
	defaultOptions: MappingOption[],
	foundFields: FoundField[] | undefined
): string[][] | null => {
	if (!foundFields || !foundFields.length) {
		return null;
	}

	const assigned = foundFields.map((f) => f.assignedField);
	const requirementsMet = minimumFields.some((combination) =>
		combination.every((field) => assigned.includes(field))
	);

	if (requirementsMet) {
		return null;
	}

	const labelById = new Map(defaultOptions.map((o) => [o.id, o.title]));

	return minimumFields.map((combination) =>
		combination.map((field) => labelById.get(field) ?? field)
	);
};
